module.exports = __webpack_public_path__ + "static/media/img-report.018c7581.png";